import { NAVIGATION_URLS } from '@libs/core';

export const generateSfccCreateAccountUrl = (selectedProductId: number) => {
    const currentPage = new URL(window.location.href);
    currentPage.searchParams.set('wishlist', String(selectedProductId));
    const redirectUrl = encodeURIComponent(
        currentPage.pathname + currentPage.search
    );
    return `${NAVIGATION_URLS.legacy.account.base}?overrideLoyaltyRedirect=true&redirectUrl=${redirectUrl}`;
};
